import pickBy from "lodash/pickBy";
import sortBy from "lodash/sortBy";
import type { Pages } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { HOME_TABS_ROOT_BLOCK_TYPE } from "../components/Blocks/HomeTabsBlock/HomeTabsRootBlocksDefaultData";
import type { ONBOARDING_ROOT_BLOCK_TYPE } from "../components/Blocks/Onboarding/ScreensRootBlocksDefaultData";
import type { HomeTabsBlock } from "../types/HomeTabs.types";

type PageType =
  | typeof HOME_TABS_ROOT_BLOCK_TYPE
  | typeof ONBOARDING_ROOT_BLOCK_TYPE;

interface PickAndSortPagesByMetaTypeAndOrderProps {
  pages: Pages;
  type: PageType;
}

export function pickAndSortPagesByMetaTypeAndOrder(props: {
  pages: Pages;
  type: "hometabs";
}): Record<string, HomeTabsBlock>;
export function pickAndSortPagesByMetaTypeAndOrder(props: {
  pages: Pages;
  type: "onboarding";
}): Pages;
export function pickAndSortPagesByMetaTypeAndOrder({
  pages,
  type,
}: PickAndSortPagesByMetaTypeAndOrderProps) {
  const filteredPages = pickBy(pages, block => block.meta?.type === type);

  const sortedEntries = sortBy(
    Object.entries(filteredPages),
    ([, block]) => block.meta?.order ?? Number.MAX_SAFE_INTEGER,
  );

  return Object.fromEntries(sortedEntries);
}
